import React, { useEffect } from 'react';
import { ReduxState } from 'interface';
import { connect, ConnectedProps } from 'react-redux';
import { useKeenSlider } from 'keen-slider/react';
import 'keen-slider/keen-slider.min.css';

const WorkspaceListSkeleton: React.FC<ConnectedProps<typeof connector>> = function (
    props: ConnectedProps<typeof connector>,
) {
    const [keenRefSkeleton, skeletonSlider] = useKeenSlider<HTMLDivElement>({
        loop: false,
        rtl: true,
        slidesPerView: 2.2,
        spacing: 24,
        mode: 'free-snap',
    });

    useEffect(() => {
        skeletonSlider?.resize();
    }, [keenRefSkeleton]);

    return (
        <div className="d-flex">
            <span className="spacer" />
            <div className={`ucheck-kiosk-ws-list keen-slider ws-list-skeleton`} ref={keenRefSkeleton}>
                {Array.from(Array(4).keys()).map((_, index) => (
                    <div className="ws-card ucheck-skeleton keen-slider__slide ws-card-skeleton" key={index} />
                ))}
            </div>
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    workspaces: state.workspacesData,
});

const connector = connect(mapStateToProps);
export default connector(WorkspaceListSkeleton);
